import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { Customer, CustomerOnlineAgent } from "@lib/types/Customer";

export const apiGetCustomer = async (customerId: string) => {
  const url = `/payment-hub-customer/${customerId}`;
  return API.get<Customer>(url);
};

export const apiAddCustomer = async (data: Customer) => {
  return API.post<Customer>(`/payment-hub-customer`, data);
};

export const apiDeleteCustomer = async (data: Customer) => {
  return API.delete<null>(`/payment-hub-customer/${data.id}`);
};

export const apiUpdateCustomer = async (data: Customer) => {
  const { id, ...rest } = data;
  return API.patch<Customer>(`/payment-hub-customer/${id}`, rest);
};

export const apiGetCustomers = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/payment-hub-customer` });
  return API.get<PaginationType<Customer>>(url);
};

export const apiGetCustomerOnlineAgent = async (customerId: string) => {
  const url = `/payment-hub-customer/online-agent?id=${customerId}`;
  return API.get<CustomerOnlineAgent>(url);
};

export const apiGetCustomerNotifyStatus = async (data: {
  id: string;
  shouldClose?: boolean;
}) => {
  const url = `/payment-hub-customer/notify/status`;
  return API.post<any>(url, data);
};
